import { ActionsObservable } from 'redux-observable';
import { flatMap, map } from 'rxjs/operators';
import { fetchJSON$ } from '../api';
import { Action, DashboardSearch } from '../store';
import { actions, actionTypes, Data } from './redux';

const getDashboardData$ = (v: DashboardSearch) => {
  return fetchJSON$(`/dashboard/investmentbytype`, v, 'GET').pipe(map(d => d as Data));
};

export const getDashboardDataEpic$ = (action$: ActionsObservable<Action<DashboardSearch>>) =>
  action$
    .ofType(actionTypes.FDI_DASHBOARD_REQUEST)
    .pipe(
      flatMap(({ payload }) => getDashboardData$(payload)),
      map(data => actions.fetchSuccess(data))
    );



// WEBPACK FOOTER //
// ./src/Dashboard/epics.ts